import { footerCols } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-background-100/90">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.4fr_2fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-water-flash-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">九色吃瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              九色吃瓜打包合集、汇总帖与大礼包在这里整理完毕，往期热门完整版一键收藏，一个页面收齐全收录内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a href="#bigpack" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600">
                <i className="ri-bookmark-line text-base"></i>
                一键收藏本页
              </a>
              <a href="#guide" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700">
                下载方向指路
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3">
            {footerCols.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-bold text-foreground-900">{col.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
                      >
                        <i className="ri-arrow-right-s-line text-foreground-300"></i>
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>九色吃瓜 · 打包合集汇总 / 大礼包 / 完整版收藏导航</p>
          <p className="inline-flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-leaf-line text-accent-600"></i>
            本页为内容归拢与方向指路，仅展示整理态结构
          </p>
        </div>
      </div>
    </footer>
  );
}